/**
 * Renders error box at top with count of sync (client-side) errors.
 * Toggle the errorToggle to get it to bounce the msg.
 */
import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Message, Transition } from '@adc/ui-core'
import { getNestedObjectPropertiesCount } from '../../utils/common'

const ErrorSyncSummary = props => {
  const { submitFailed, invalid, formSyncErrors, errorToggle } = props
  const errorCount = getNestedObjectPropertiesCount(formSyncErrors)
  const onlyOne = errorCount === 1

  if (!submitFailed || !invalid || _.isEmpty(formSyncErrors)) {
    return null
  }

  // visible below is used to start animation - not actually hide/show
  return (
    <Transition animation='pulse' duration={300} visible={errorToggle}>
      <Message negative data-elm-id='sync_error_summary'>
        <Message.Header>
          Oops! {`There ${onlyOne ? 'is' : 'are'} `}
          <strong>{errorCount}</strong> {`error${onlyOne ? '' : 's'} `}
          {`that require${onlyOne ? 's' : ''}`} your attention.
        </Message.Header>
      </Message>
    </Transition>
  )
}

ErrorSyncSummary.propTypes = {
  submitFailed: PropTypes.bool,
  invalid: PropTypes.bool,
  formSyncErrors: PropTypes.object,
  errorToggle: PropTypes.bool,
}

export default ErrorSyncSummary
